<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        ADDRESS_API,
        AlertBar,
        Modal,
        Paragraph,
        ProgressLine,
        SESSION_ORGANIZATION,
        SESSION_USER,
        SUBSCRIPTION_API,
        USER_API,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import Overview from './components/Overview.svelte';
    import OrganizationForm from './components/organization/OrganizationForm.svelte';
    import Subscription from './components/subscriptions/SubscriptionForm.svelte';
    import EmailConfirmation from './components/confirmation/EmailConfirmation.svelte';
    import ResendEmail from './components/confirmation/ResendConfirmation.svelte';
    import UpdateEmail from './components/confirmation/UpdateEmail.svelte';
    import Financing from './components/financing/Financing.svelte';
    import FinancingForm from './components/financing/FinancingForm.svelte';
    import Logistics from './components/logistics/Logistics.svelte';
    import LogisticsForm from './components/logistics/LogisticsForm.svelte';
    import OrganizationUsers from './components/organization/OrganizationUsers.svelte';

    // STORES
    import { IS_ONBOARDING, ONBOARDING_PROGRESS } from './store';

    // UTILS
    import { onMount } from 'svelte';

    /* INTERNALS ------------------------------------------------------------------------------- */

    onMount(async () => {
        /* eslint-disable array-element-newline */
        await Promise.all([
            USER_API.filterUsers({ organizationKey: $SESSION_ORGANIZATION?._.key }),
            ADDRESS_API.filterAddresses({ organizationKey: $SESSION_ORGANIZATION?._.key }),
            SUBSCRIPTION_API.filterSubscriptions({ ownerKey: $SESSION_USER?._.key }),
        ]);
        /* eslint-enable */
    });

</script>

{#if $IS_ONBOARDING && $SESSION_ORGANIZATION?.domain !== 'internal'}

    <Modal hash = '#onboarding' closeOnOutsideClick = { false }>
        <Overview />
    </Modal>

    <Modal hash = '#onboarding/organization' closeOnOutsideClick = { false }>
        <OrganizationForm/>
    </Modal>

    <Modal hash = '#onboarding/subscriptions' closeOnOutsideClick = { false }>
        <Subscription />
    </Modal>

    <Modal hash = '#onboarding/confirmation' closeOnOutsideClick = { false }>
        <EmailConfirmation/>
    </Modal>

    <Modal hash = '#onboarding/confirmation-resend' closeOnOutsideClick = { false }>
        <ResendEmail />
    </Modal>

    <Modal hash = '#onboarding/confirmation-update' closeOnOutsideClick = { false }>
        <UpdateEmail/>
    </Modal>

    <Modal hash = '#onboarding/financing' closeOnOutsideClick = { false }>
        <Financing />
    </Modal>

    <Modal hash = '#onboarding/financing-form' closeOnOutsideClick = { false }>
        <FinancingForm />
    </Modal>

    <Modal hash = '#onboarding/logistics' closeOnOutsideClick = { false }>
        <Logistics />
    </Modal>

    <Modal hash = '#onboarding/logistics-form' closeOnOutsideClick = { false }>
        <LogisticsForm />
    </Modal>

    <Modal hash = '#onboarding/organization-users' closeOnOutsideClick = { false }>
        <OrganizationUsers />
    </Modal>

    <AlertBar url = '#onboarding'>
        <div class = 's8-alert-bar'>
            <Paragraph color = 'light'>Onboarding { $ONBOARDING_PROGRESS }% completed.</Paragraph>
            <div class = 's8-line'>
                <ProgressLine progress = { $ONBOARDING_PROGRESS } mode = 'dark' />
            </div>
        </div>
    </AlertBar>

{/if}

<style lang='postcss'>

    div.s8-alert-bar {
        display: flex;
        flex-direction: column;
        align-items: center;

        :global(p) {
            margin-bottom: 0px;
            position: relative;
            top: -4px;
        }

        & div.s8-line {
            width: 100%;

            :global(div.s8-progress-line) {
                height: 0px;
            }
        }
    }

</style>